import React, {useEffect, useState} from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import ButtonExit from "../button/ButtonExit";
import ButtonAdd from "../button/ButtonAdd";
import MaterialPageItemModule from "../modul/MaterialPageItemModule";

const ModalEditMaterial = ({
                               open,
                               handleClose,
                               handleSubmit,
                               handleModalAlert,
                               initValue,
                               loading
                           }) => {
    const [data, setData] = useState(initValue);

    useEffect(() => {
        setData(initValue)
    }, [open])

    return (
        <div>
            <Dialog open={open} onClose={handleClose} PaperProps={{
                style: {
                    minWidth: `1500px`,
                }
            }}>
                <DialogTitle textAlign="center">Выбрать материал</DialogTitle>
                <DialogContent>
                    <MaterialPageItemModule
                        isOrganization={false}
                        selectMaterialId={data.materialId}
                        selectMaterial={(material) => setData({
                            ...data,
                            materialId: material.id,
                            materialName: material.name
                        })}
                        subTypeMaterial={data.subTypeMaterial}
                        modal={true}
                        handleModalAlert={handleModalAlert}
                    />
                </DialogContent>
                <DialogActions sx={{p: '1.25rem'}}>
                    <ButtonExit text={"Выйти"} onClick={handleClose}/>
                    <ButtonAdd
                        loading={loading}
                        text={"Выбрать"} disabled={!data.materialId}
                        onClick={() => handleSubmit(data, handleClose)}
                    />
                </DialogActions>
            </Dialog>
        </div>
    );
};
export default ModalEditMaterial